"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../../../../utils");
var _ui = require("../../../../../ui");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  ", "\n"])), _utils.mediaQuery.lessThan('xs')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]))));
var Item = function Item(_ref) {
  var title = _ref.title,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: "d-flex justify-content-between ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_ui.P, {
    className: "me-3"
  }, title), children);
};
exports.Item = Item;